import { render, staticRenderFns } from "./MessageTemplateByShiseidoPrelapsed.vue?vue&type=template&id=192b5366"
import script from "./MessageTemplateByShiseidoPrelapsed.vue?vue&type=script&lang=js"
export * from "./MessageTemplateByShiseidoPrelapsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports